export const userList = "v1/admin/user_list";

export const delete_user= "v1/user/delete_user";

export const userCreation = "admins/create_user";

export const userUpdate = "admins/update_user";

export const updateConsultant = "admins/update_consultant";

export const languagesList = "language/list";

export const addLanguage = "language/add_language";

export const servicesList = "service/list";

export const addService = "service/add_service";

export const expertiseList = "expertise/list";

export const addExpertise = "expertise/add_expertises";

export const rechargeList = "v1/admin/subscriptions_list";

export const addRecharge = "v1/admin/create_plan";

export const credentialsList = "v1/admin/credentials_list";

export const addCredentials = "v1/admin/create_credentials";

export const updateCredentials = "v1/admin/update_credentials";

export const consultant = "consultant/list";

export const StatusConsultant = "admins/approved";

export const consultant_Active = "admins/permission";

export const AdminList = "admins/list";

export const UpdateAdmin = "admins/update_admin";

export const recording = "admins/pending_recordings_list";

export const uploadImage = "upload_file/image";

export const updateRecordingStatus = "admins/approve_recording";

export const getConsultantBalance = "admins/consultants_by_balance";

export const getBanks = "admins/consultants_by_pending_bank_details";

export const approveBank = "admins/approve_partner_bank_details";

export const postCredentials = "consultant/fund_transfer";

export const Admin = "admins/create";

export const subAdmin = "admins/sub_admins_list";

export const updateAdminStatus = "admins/change_status";

export const updateConsultantAudio = "voice_type/update_status";

export const PlanFetch = "v1/admin/subscriptions_list";

export const otp = "v1/session/login";

export const rechargeDelete = "v1/admin/delete_plan";

export const getConsultantUserRecharge = "admins/update_balance";

export const EditDetails = "expertise/update";

export const EditServiceDetails = "service/update";

export const updateLanguageDetail = "language/update";

export const updateCredentialsDetail = "v1/admin/update_credentials";

export const userStatus = "admins/permission";

export const DeleteApi = "v1/user/delete_user";

export const updatePassword = "admins/change_password";

export const dashboarduri = "v1/admin/transactions_list";

export const statusuri = "analytics/overall";

export const updateAdminPassword = "admins/reset_password";

export const userdelete = "v1/user/delete_account";

export const ExcelFile = "admins/update_fund_details"

export const campaignsList = "v1/admin/campaigns_list";
export const campaignCreate = "v1/admin/create_campaign";
export const campaignSend = "v1/admin/send_campaign";
export const campaignDelete = "v1/admin/delete_campaign";